import React, { useState } from 'react'
import Search from './search'
import IconBox from './icon-box'
import ImmutableData from './immutable-data'
import MutableData from './mutable-data'
import GenesisData from './genesis-data'
import * as displayStyles from '../styles/display.module.scss'
import BigNumber from 'bignumber.js'

const SlpMutableData =
  typeof window !== 'undefined'
    ? require('slp-mutable-data').SlpMutableData
    : null

// const GATEWAY = 'ipfs-gateway.fullstackcash.nl'// 'p2wdb-gateway-678.fullstack.cash/'

const Display = (props) => {
  // states
  const { wallet } = props
  const [success, setSuccess] = useState(null)
  const [mutableData, setMutableData] = useState(null)
  const [immutableData, setImmutableData] = useState(null)
  const [genesisData, setGenesisData] = useState(null)
  const [tokenIcon, setTokenIcon] = useState(null)
  const [inFetch, setInFetch] = useState(null)
  const [errorMsg, setErrorMsg] = useState(null)

  const onSearch = async (tokenId) => {
    try {
      resetStates()
      setInFetch(true)

      const slpMutableData = new SlpMutableData({
        wallet,
        cidUrlType: 1,
        ipfsGatewayUrl: 'pearson-ipfs-gateway.fullstackcash.nl'
      })

      // slpMutableData.get.bchjs = bchjs

      const data = await slpMutableData.get.data(tokenId)
      // console.log('data', data)
      const _mutableData = Object.entries(data.mutableData).length === 0 ? null : data.mutableData
      const _immutableData = Object.entries(data.immutableData).length === 0 ? null : data.immutableData
      const _tokenIcon = (_mutableData && _mutableData.tokenIcon) || null
      const _tokenStats = parseGenesisData(data.tokenStats) // set to readable object

      setImmutableData(_immutableData)
      setMutableData(_mutableData)
      setGenesisData(_tokenStats)
      setTokenIcon(_tokenIcon)
      setInFetch(false)
      setSuccess(true)
    } catch (error) {
      setInFetch(false)
      setSuccess(false)
      handleError(error)
      console.warn('Error in index/onSearch()', error)
    }
  }

  const handleError = (error) => {
    try {
      let errMsg = 'Error'
      if (error.message) {
        errMsg = error.message
      } else if (error.error && error.error.error) {
        errMsg = error.error.error
      } else if (error.error) {
        errMsg = error.error
      }
      setErrorMsg(errMsg)
    } catch (error) {
      console.warn(error)
    }
  }

  const parseGenesisData = (tokenStats) => {
    try {
      const {
        tokenId,
        ticker,
        name,
        documentUri,
        documentHash,
        type,
        decimals,
        mintBatonIsActive,
        totalMinted,
        totalBurned,
        tokensInCirculationBN
      } = tokenStats

      const data = {
        'token id': tokenId,
        ticker: ticker,
        name: name,
        'document URL': documentUri,
        'document Hash': documentHash,
        decimals: decimals,
        mintBatonIsActive: mintBatonIsActive,
        'total minted': getReadableNumber(totalMinted, decimals),
        'tokens in circulation': getReadableNumber(tokensInCirculationBN, decimals),
        'total burned': getReadableNumber(totalBurned, decimals),
        type: type === 1 ? 'fungible' : type

      }
      console.log(data)
      return data
    } catch (error) {
      console.warn('error in parseGenesisData()')
      handleError(error)
      return false
    }
  }
  const getReadableNumber = (number, decimals) => {
    const bigN = new BigNumber(number).div(10 ** decimals)
    return bigN.toString()
  }
  const resetStates = () => {
    setErrorMsg(null)
    setSuccess(false)
    setTokenIcon(null)
    setImmutableData(null)
    setMutableData(null)
  }
  return (
    <main className={displayStyles.wrapper}>
      <h1 className={displayStyles.title}>TOKEN DISPLAY</h1>
      <Search onSearch={onSearch} tokenId={props.tokenId} />
      {!inFetch && (
        <div>
          {tokenIcon && <IconBox icon={tokenIcon} />}
          {success && <ImmutableData immutableData={immutableData} />}
          {success && <MutableData mutableData={mutableData} />}
          {success && <GenesisData genesisData={genesisData} />}

        </div>
      )}
      {inFetch && <div className={displayStyles.loader} />}
      {errorMsg &&
        <p className={displayStyles.errorColor}>
          {errorMsg}
        </p>}
    </main>
  )
}

export default Display
